module.exports = __webpack_public_path__ + "img/cases-brand-13-cover.087db540.png";